import Search from 'components/commons/search'
import { Button } from 'avo-ui'
import icTrash from 'assets/images/ic-trash.svg'
import { ACTION_TYPE } from 'constants/constant'
import icAddSquare from 'assets/images/ic-add-square.svg'
import Table from 'components/commons/table'
import ModalDelete from 'components/commons/modal-delete'
import {
    FILTER_BENEFIT_REDEEM_POINT,
    TABLE_BENEFIT_REDEEM_POINT,
} from 'configs/loyalty-program/configTableBenefitRedeemPoint'
import Filter from 'components/commons/filter'
import { FormBenefitRedeemPoint } from 'components/loyalty-program/benefit-redeem-point/FormBenefitRedeemPoint'

export const BenefitRedeemPoint = ({
    dataList,
    modal,
    setShowModal,
    query,
    queryFilter,
    onChangeQuery,
    onFilter,
    selectedIds,
    onDelete,
    onSelectItemHandler,
    onActionRow,
    onChangeForm,
    options,
    onSearchOptions,
    onSubmit,
    onHideForm,
    errorForm,
    isResetSelectedItem,
    benefitRedeemPointDetail,
    isLoading,
    isDeleting,
    isCreating,
    isUpdating,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex gap-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <Filter
                        show={modal?.filter}
                        setShow={(value) => setShowModal({ filter: value })}
                        options={FILTER_BENEFIT_REDEEM_POINT}
                        values={queryFilter}
                        onSubmit={(value) => onFilter(value)}
                    />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!selectedIds?.length}
                        onClick={() => onActionRow({ actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create Benefit Redeem Point'}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_BENEFIT_REDEEM_POINT.name}
                columns={TABLE_BENEFIT_REDEEM_POINT.column}
                data={dataList?.benefits}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete Benefit Redeem Point'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.form && (
                <FormBenefitRedeemPoint
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataBenefitRedeemPoint={benefitRedeemPointDetail}
                    options={options}
                    onSearchOptions={onSearchOptions}
                    isLoading={isCreating || isUpdating}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
